<div class="reports-container">
  <div class="page-header">
    <h1 class="page-title">Reports</h1>
    <app-reports-nav></app-reports-nav>
  </div>

  <mat-card class="filter-card">
  <div class="filters-row">
    <!-- The Type dropdown had a single option (QA 2026-10-04); the Distribution tab already says it. -->
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-field">
      <mat-label>Distribution label</mat-label>
      <input matInput [(ngModel)]="filterLabel" (keyup.enter)="onSearch()" placeholder="e.g. October Distribution">
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-field">
      <mat-label>Month</mat-label>
      <mat-select [(ngModel)]="filterMonth">
        @for (month of months; track month.value) {
          <mat-option [value]="month.value">{{ month.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-field">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="filterStatus">
        @for (opt of statusOptions; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <button mat-flat-button color="primary" class="search-btn" (click)="onSearch()">
      <mat-icon>search</mat-icon>
      Search
    </button>
  </div>
  </mat-card>

  @if (activeFilters.length > 0) {
    <div class="active-filters-row">
      <span class="active-filters-label">Active filters:</span>
      <mat-chip-set>
        @for (filter of activeFilters; track filter) {
          <mat-chip (removed)="removeFilter(filter)">
            {{ filter }}
            <button matChipRemove aria-label="Remove filter">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        }
      </mat-chip-set>
    </div>
  }

  <div class="mat-elevation-z2 table-container">
    <table mat-table matSort [dataSource]="dataSource" aria-label="Distributions">

      <ng-container matColumnDef="period">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="periodStart">Distribution Period</th>
        <td mat-cell *matCellDef="let row">
          @if (row.label) { <strong>{{ row.label }}</strong><br> }
          {{ formatPeriod(row.periodStart, row.periodEnd) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="grossCollected">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="grossCollected">Gross Collected</th>
        <td mat-cell *matCellDef="let row">
          {{ row.grossCollected | currency:'USD':'symbol':'1.2-2' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
        <td mat-cell *matCellDef="let row">
          <span class="status-badge" [ngClass]="'status-' + row.status.toLowerCase().replace('_', '-')">
            {{ getStatusLabel(row.status) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row" class="actions-cell">
          <button mat-stroked-button class="action-btn rerun-btn"
            (click)="onRerun($event, row.id)"
            [disabled]="row.status === DistributionStatus.FINALIZED || row.status === DistributionStatus.VOID">
            RERUN
          </button>
          <button mat-flat-button color="primary" class="action-btn approve-btn"
            (click)="onApprove($event, row.id)"
            [disabled]="row.status !== DistributionStatus.READY">
            APPROVE
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="clickable-row"
        [routerLink]="['/app/distributions/runs']" [queryParams]="{ run: row.id }">
      </tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
          No distributions match the current filters.
        </td>
      </tr>
    </table>

    <mat-paginator #paginator
      [length]="dataSource.data.length"
      [pageIndex]="0"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]"
      aria-label="Select page">
    </mat-paginator>
  </div>
</div>
